import React from "react";
import { Link } from "react-router-dom";
import config from "../data/siteConfig";
import { ScallopDivider, Peacock } from "./Decor";
import { FiMapPin, FiPhone, FiGlobe } from "react-icons/fi";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaGoogle } from "react-icons/fa";

export default function Footer() {
  const c = config.contact;
  return (
    <footer id="footer" className="relative overflow-hidden bg-coffee-950 text-cream/80">
      <ScallopDivider className="block h-3 w-full" />
      {/* subtle peacock watermark — sits behind the content, away from the buttons */}
      <Peacock className="pointer-events-none absolute right-2 top-8 z-0 hidden h-72 w-52 text-gold/10 lg:block" />

      <div className="container-x relative z-10 grid gap-10 py-16 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <img src={config.brand.logo} alt={config.brand.name} className="h-20 w-auto drop-shadow" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed">
            {config.brand.name} — {config.brand.house}. Authentic BIS Hallmark gold &amp; bridal
            jewellery from the heart of Bhachau, Kutch.
          </p>
          <p className="gu mt-3 text-gold-light/70">{config.brand.nameGu}</p>

          {/* social */}
          <div className="mt-5 flex gap-3">
            {[
              [FaFacebookF, "Facebook", c.social.facebook],
              [FaInstagram, "Instagram", c.social.instagram],
              [FaGoogle, "Google Reviews", c.social.googleReviews],
            ].map(([Ic, label, href]) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                title={label}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/40 text-gold-light transition-colors hover:bg-gold hover:text-coffee-900"
              >
                <Ic />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-display tracking-wide text-gold-light">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {[["About Us", "/#about"], ["Collections", "/#collections"], ["Gallery", "/#gallery"], ["Wedding", "/#wedding"], ["Visit Us", "/#visit"]].map(([t, h]) => (
              <li key={h}><a className="hover:text-gold-light" href={h}>{t}</a></li>
            ))}
            <li><Link className="hover:text-gold-light" to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link className="hover:text-gold-light" to="/terms-conditions">Terms &amp; Conditions</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display tracking-wide text-gold-light">Reach Us</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><FiMapPin className="shrink-0 text-gold-light" /> Bhachau, Kutch, Gujarat</li>
            <li className="flex items-center gap-2"><FiPhone className="shrink-0 text-gold-light" /> <a className="hover:text-gold-light" href={`tel:${c.phonePrimary.replace(/\s/g, "")}`}>{c.phonePrimary}</a></li>
            <li className="flex items-center gap-2"><FaWhatsapp className="shrink-0 text-gold-light" /> <a className="hover:text-gold-light" href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noreferrer">WhatsApp</a></li>
            <li className="flex items-center gap-2"><FiGlobe className="shrink-0 text-gold-light" /> {config.brand.domain}</li>
          </ul>
        </div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center gap-1.5 border-t border-gold/20 py-5 text-center text-xs text-cream/60 sm:flex-row sm:gap-3">
        <span>© {config.brand.name}. All rights reserved.</span>
        <span className="hidden text-gold/40 sm:inline">|</span>
        <span className="flex items-center gap-1.5">
          Developed by
          <a
            href="https://www.shreepatisystems.com/"
            target="_blank"
            rel="noreferrer"
            className="text-gold-light hover:underline"
          >
            Shreepati Systems
          </a>
        </span>
      </div>
    </footer>
  );
}
